// FE-only convenience: suggest a kebab-case slug from a title. The server is the
// source of truth — it re-validates kebab-case and sibling uniqueness.
export function slugify(input: string): string {
  return input
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
